<template>
    <div class="dynamic-list">
        <div v-for="(item, index) in modelValue" :key="index" class="feature-row">
            <el-select v-model="item.item_key" filterable allow-create default-first-option placeholder="选择或输入权益 key">
                <el-option v-for="feature in quotaFeatures" :key="feature.key" :label="feature.name + '（' + feature.key + '）'"
                    :value="feature.key"></el-option>
            </el-select>
            <el-input-number v-if="isQuota(item.item_key)" :model-value="toNumber(item.item_value)" :min="0" :precision="0"
                placeholder="非负整数" @update:modelValue="item.item_value = $event == null ? '' : String($event)"></el-input-number>
            <el-input v-else v-model.trim="item.item_value" placeholder="展示文案"></el-input>
            <el-input-number v-model="item.sort_order" :min="0" :precision="0" placeholder="排序"></el-input-number>
            <el-button type="danger" size="mini" @click="$emit('remove', item, index)">删除</el-button>
        </div>
        <el-button type="primary" plain size="small" @click="add">添加权益</el-button>
        <div class="help-text">配额型 key（下拉内置项）的值必须是非负整数；自定义 key 为展示型，值为 App 端展示文案。feeding_plan_limit 实际生效值最大 15。</div>
    </div>
</template>

<script>
import { QUOTA_FEATURES, QUOTA_KEYS } from './constants'

export default {
    name: 'PetFeatureEditor',
    props: { modelValue: { type: Array, required: true } },
    emits: ['remove', 'update:modelValue'],
    data() {
        return { quotaFeatures: QUOTA_FEATURES }
    },
    methods: {
        isQuota(key) { return QUOTA_KEYS.includes(key) },
        toNumber(value) { return value === '' || value == null || isNaN(Number(value)) ? undefined : Number(value) },
        add() {
            this.$emit('update:modelValue', [
                ...this.modelValue,
                { item_key: '', item_value: '', sort_order: this.modelValue.length + 1 }
            ])
        }
    }
}
</script>

<style scoped>
.dynamic-list { width: 100%; }
.feature-row { display: flex; gap: 10px; align-items: center; margin-bottom: 10px; }
.feature-row .el-select { width: 300px; }
.feature-row .el-input { flex: 1; }
.help-text { margin-top: 8px; color: #909399; font-size: 12px; line-height: 1.5; }
</style>
